module.exports = __webpack_public_path__ + "img/table.11c7e1ab.png";